// import components
import { GridColDef, GridValidRowModel } from '@mui/x-data-grid-pro';

// import hooks
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useGetColumns = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.settings.kidsPlan.fields'
  });

  return useMemo(
    () => [
      {
        headerName: t('username'),
        field: 'username',
        type: 'number',
        headerAlign: 'left',
        flex: 1
      },
      {
        headerName: t('host'),
        field: 'hostName',
        type: 'string',
        flex: 1
      },
      {
        headerName: t('apiPrefix'),
        field: 'apiPrefix',
        type: 'string',
        flex: 1
      },
      {
        headerName: t('clientId'),
        field: 'clientId',
        type: 'string',
        flex: 1
      },
      {
        headerName: t('apiKey'),
        field: 'apiKey',
        type: 'string',
        flex: 1
      }
    ],
    [t]
  ) as GridColDef<GridValidRowModel>[];
};
